// Prod_US upload screen: after the second test, both videos upload here, one after the other.
// Same layout and class names as the app's VideoUploadedSuccess (videoupload.scss).
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserDetailsHeader from "../userDetail/UserDetailsHeader";
import uploadSuccess from "../../assets/images/videoUploadSuccess.svg";
import "../userDetail/videoUpload/videoupload.scss";
import "./prodUs.scss";
import { userInfoFetch } from "../../utlis/commonFunction";
import { getModuleName } from "../../utlis/measurementModuleLabels";
import { clearProdUsVideos, uploadProdUsVideos } from "./prodUsDeferredUpload";
import { personPagePath } from "./prodUsSession";
import { PROD_US_MODULE_IDS } from "./prodUsConfig";
import { pt } from "./prodUsStrings";

const ProdUsUpload = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [status, setStatus] = useState("uploading"); // uploading | done | failed | missing
  const cancelled = useRef(false);
  const started = useRef(false);

  const run = async () => {
    setStatus("uploading");
    const result = await uploadProdUsVideos({
      onProgress: setIndex,
      isCancelled: () => cancelled.current,
    });
    if (cancelled.current) return;
    setStatus(result.status === "cancelled" ? "uploading" : result.status);
  };

  useEffect(() => {
    if (started.current) return; // React 18 dev mode runs effects twice
    started.current = true;
    run();
  }, []);

  const toPersonPage = () =>
    navigate(personPagePath(userInfoFetch()), { replace: true });

  const cancel = () => {
    cancelled.current = true;
    clearProdUsVideos();
    toPersonPage();
  };

  const dots = (
    <div className="measurement-session-strip">
      <div className="session-progress-row">
        <div className="session-dots" aria-hidden="true">
          {PROD_US_MODULE_IDS.map((id, k) => (
            <span
              key={id}
              className={`session-dot ${k < index ? "done" : k === index ? "cur" : ""}`}
            />
          ))}
        </div>
        <div className="session-label">
          {pt("upload_count", {
            current: index + 1,
            total: PROD_US_MODULE_IDS.length,
          })}
        </div>
      </div>
    </div>
  );

  let body;
  if (status === "done") {
    body = (
      <div className="video-upload-content-wrap">
        <img src={uploadSuccess} alt="success" className="img" />
        <p className="success-msg">{pt("upload_success")}</p>
        <p className="report-msg">{pt("alert_info")}</p>
        <button type="button" className="done-btn" onClick={toPersonPage}>
          {pt("done")}
        </button>
      </div>
    );
  } else if (status === "failed" || status === "missing") {
    body = (
      <div className="video-upload-content-wrap">
        <p className="success-msg" role="alert">
          {pt(status === "failed" ? "upload_failed" : "videos_missing")}
        </p>
        {status === "failed" ? (
          <button type="button" className="done-btn" onClick={run}>
            {pt("retry")}
          </button>
        ) : null}
        <button
          type="button"
          className="measurement-cancel-btn pu-upload-cancel"
          onClick={cancel}
        >
          {status === "failed" ? pt("cancel_upload_btn") : pt("done")}
        </button>
      </div>
    );
  } else {
    body = (
      <div className="video-upload-content-wrap">
        <div className="pu-spinner" aria-hidden="true" />
        <p className="success-msg" role="status">
          {pt("video_uploading")}
        </p>
        <p className="report-msg">{pt("upload_alert")}</p>
        <button type="button" className="done-btn" onClick={cancel}>
          {pt("cancel_upload_btn")}
        </button>
      </div>
    );
  }

  return (
    <UserDetailsHeader
      className="measurement-shell pu-no-back"
      onBack={() => {}}
    >
      <div className="video-upload-status-wrappper pu-upload">
        {status === "done" ? null : (
          <>
            {dots}
            <p className="title">
              {getModuleName({ moduleId: PROD_US_MODULE_IDS[index] })}
            </p>
          </>
        )}
        {body}
      </div>
    </UserDetailsHeader>
  );
};

export default ProdUsUpload;
